import React, { useEffect, useRef, useState } from "react";
import PageLoading from "components/PageLoading";
import ErrorLabel from "components/ErrorLabel";
import "./index.scss";
import { getErrorMsg, getGaugeData, gaugeLayout } from "utils/gaugeUtils";
import { connect } from "react-redux";
import * as Plotly from "plotly.js";

const Gauge = ({ report, data, isLoading, systemsStatus, layout, width, setError }) => {
  const [gaugeData, setGaugeData] = useState(null);
  const plotRef = useRef(null);

  const isValueError = () => {
    if (data && data.GaugeData) {
      const { GaugeData, Tags } = data;
      const { LL, HH } = GaugeData;
      const gaugeTag = Tags.length ? Tags[0] : null;
      const { Value } = gaugeTag || 0;
      return Value < LL.Value || Value > HH.Value;
    }
  };

  const isSystemOfflineOrHasError = () => {
    const isError = isValueError() || (systemsStatus ? systemsStatus[0].connectionStatus === 0 : false);
    if (isError) {
      report.error = getErrorMsg(isError);
      setError(report.error);
    }
    return isError;
  };

  useEffect(() => {
    if (report && data && data.GaugeData && data.Data) {
      const { GaugeData, Tags, Data } = data;
      const { LL, L, H, HH } = GaugeData;
      const gaugeMean = Data?.Data?.mean;
      if (gaugeMean) {
        Tags[0].Value = gaugeMean[0];
      }
      const gaugeTag = Tags[0];
      report.gaugeData = getGaugeData(gaugeTag.Value, gaugeTag.Units, L, LL, H, HH, report.SubType);
      setGaugeData(report.gaugeData);
    }
  }, [data]);

  useEffect(() => {
    const id = "plotly_div_gauge" + report.Id;
    if (gaugeData && document.getElementById(id) != null) {
      layout = { ...layout, width: width, height: 180 };
      Plotly.newPlot("plotly_div_gauge" + report.Id, gaugeData, gaugeLayout, { displayModeBar: false, staticPlot: true }).then(function (gd) {
        Plotly.toImage(gd, { height: 400, width: 800, format: "png", scale: 1 }).then(function (url) {
          report.url = url;
          report.isLoaded = true;
        });
      });
    }
  }, [gaugeData, report.error]);

  return (
    <>
      {isValueError() && !isLoading && (
        <div className="flex-center-center marginTop20">
          <ErrorLabel message={getErrorMsg(isSystemOfflineOrHasError())} />
        </div>
      )}
      <div className={`flex-center-center`}>
        <div className="d-flex gaugeMainContainer flex-center-center">
          {isLoading ? (
            <PageLoading customHeight="230px" />
          ) : (
            <div className="flex-center-center" id={`plotly_div_gauge${report.Id}`} ref={plotRef} />
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ poll }) => {
  return {
    systemsStatus: poll.systemsStatus
  };
};

export default connect(mapStateToProps, null)(Gauge);
